/* Will remove data from storage */
import { Injectable } from '@angular/core';
import { CookieService } from './cookie.shared.service';

import * as Utils from '@shared/core/utils';

@Injectable({
    providedIn: 'root',
})
export class CleanService {
    constructor(public cookiesService: CookieService) {}

    public cookiesStorage(): void {
        this.cookiesService.removeAll();
    }

    public localStorage(): void {
        Utils.Storage.clear();
    }

    public clearLocalStorageByCategory(category: string): void {
        Utils.Storage.clearByCategory(category);
    }

    public sessionStorage(): void {
        Utils.Storage.clear('sessionStorage');
    }

    public clearAllStorageTypes(): void {
        this.cookiesStorage();
        this.localStorage();
        this.sessionStorage();
    }

    public clearForSignIn(): void {
        /* Is registering or logging in - gathering data in sessionStorage */
        this.cookiesStorage();
        this.localStorage();
    }

    public clearLocalStorageForCategories(categories: OLO.Types.LOCAL_STORAGE_CATEGORY[]) {
        for (const category of categories) {
            this.clearLocalStorageByCategory(category);
        }
    }
}
